(function(){ var tovDup = false; try { var tovK = 'tov_ty_fired', tovN = Date.now(), tovP = window.localStorage.getItem(tovK); if (tovP && tovN - parseInt(tovP, 10) < 86400000) { tovDup = true; } else { window.localStorage.setItem(tovK, String(tovN)); } } catch (e) {}
  /* ============================================================
     UNIVERSAL THANK-YOU PAGE — conversion tracking
     ============================================================
     This page loading IS the conversion signal, regardless of which
     consultation form the visitor came from. Fill in your real
     IDs/labels below. Anything left as a placeholder is safely
     skipped (wrapped in try/catch) so it won't break the page if
     you haven't set it up yet.
  ============================================================ */

  // ---------- 1. Google Ads conversion (via gtag.js) ----------
  // Only fires if gtag.js is already loaded on your store (Shopify's
  // native "Google & YouTube" sales channel usually loads this for you).
  try {
    if (!tovDup && typeof gtag === 'function') {
      gtag('event', 'conversion', {
        // TODO: replace with your real Conversion ID / Label from
        // Google Ads → Goals → Conversions → your action → "Tag setup"
        'send_to': 'AW-17749078920/o0aDCMXZjNkcEIjntY9C'
      });
    }
  } catch (e) {}

  // ---------- 2. GA4 event (optional, separate from Ads conversion) ----------
  try {
    if (!tovDup && typeof gtag === 'function') {
      gtag('event', 'generate_lead', {
        'event_category': 'Consultation',
        'event_label': document.title
      });
    }
  } catch (e) {}

  // ---------- 3. Meta Pixel (only if you run Facebook/Instagram ads) ----------
  try {
    if (!tovDup && !window.__tovLeadFired) {
      window.__tovLeadFired = true;

      var eventId = 'lead_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
      window.tovLeadEventId = eventId;

      var fireLead = function (attempt) {
        attempt = attempt || 0;
        if (typeof fbq === 'function') {
          fbq('track', 'Lead', {
            content_name: 'Gemstone Consultation',
            content_category: 'Consultation Booking'
          }, { eventID: eventId });
        } else if (attempt < 20) {
          setTimeout(function () { fireLead(attempt + 1); }, 250);
        }
      };

      fireLead();
    }
  } catch (e) {}

  /* ============================================================
     Entrance polish — replays the CSS rise/pop animations if the
     browser restores this page from cache (back button, etc.)
  ============================================================ */
  window.addEventListener('pageshow', function(e){
    if (e.persisted) {
      var root = document.getElementById('tov-thankyou');
      if (!root) return;
      var animated = root.querySelectorAll('.ty-icon,.eyebrow,h1,.lede,.ty-steps,.ty-ctas,.ty-note');
      animated.forEach(function(el){
        el.style.animation = 'none';
        void el.offsetWidth; // force reflow so the animation can restart
        el.style.animation = '';
      });
    }
  });
})();